var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.0048C13.6569 14.0048 15 12.6616 15 11.0048C15 9.34792 13.6569 8.00478 12 8.00478C10.3431 8.00478 9 9.34792 9 11.0048C9 12.6616 10.3431 14.0048 12 14.0048Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.657 16.7874L13.414 21.1486C13.039 21.5337 12.5306 21.75 12.0005 21.75C11.4704 21.75 10.962 21.5337 10.587 21.1486L6.343 16.7874C5.22422 15.6373 4.46234 14.1721 4.15369 12.577C3.84504 10.982 4.00349 9.32861 4.60901 7.82608C5.21452 6.32356 6.2399 5.03933 7.55548 4.13579C8.87107 3.23226 10.4178 2.75 12 2.75C13.5822 2.75 15.1289 3.23226 16.4445 4.13579C17.7601 5.03933 18.7855 6.32356 19.391 7.82608C19.9965 9.32861 20.155 10.982 19.8463 12.577C19.5377 14.1721 18.7758 15.6373 17.657 16.7874V16.7874Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.bc7df4e3.svg";
export { ForwardRef as ReactComponent };